"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _colors = require("HubStyleTokens/colors");

var _PageConstants = require("./PageConstants");

var _UIAbstractPageGridContent = _interopRequireDefault(require("./UIAbstractPageGridContent"));

var _UIAbstractPageSection = _interopRequireDefault(require("./UIAbstractPageSection"));

var _UIPage = _interopRequireDefault(require("./UIPage"));

var _UIHeader = _interopRequireDefault(require("../layout/UIHeader"));

var CustomRenderer = _interopRequireWildcard(require("../utils/propTypes/customRenderer"));

var _deprecated = _interopRequireDefault(require("../utils/propTypes/deprecated"));

var _lazyEval = _interopRequireDefault(require("../utils/lazyEval"));

var _createLazyPropType = _interopRequireDefault(require("../utils/propTypes/createLazyPropType"));

var _component = _interopRequireDefault(require("../utils/propTypes/component"));

var _NavHeight = require("../utils/NavHeight");

var _Styles = require("../utils/Styles");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1; /* Only needed for IE11: #1992 */\n  background-color: ", ";\n  min-height: calc(100vh - ", ");\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function mainWrapperBackgroundColor(color) {
  return {
    backgroundColor: color
  };
}

function renderHeader(headerComponent, headerUse, alertComponent, title) {
  var headerOptions = {
    title: title,
    use: headerUse
  };

  if (alertComponent) {
    headerOptions = (0, _extends2.default)({
      alert: alertComponent
    }, headerOptions);
  }

  return CustomRenderer.render(headerComponent, headerOptions);
}

function getBodyClassNames(bodyClassName, pageLayout) {
  return (0, _classNames.default)('space-sword', bodyClassName, {
    'space-sword--max-width': pageLayout === 'max-width'
  });
}

var StyledPage = (0, _styledComponents.default)(function (props) {
  var __navHeight = props.navHeight,
      rest = (0, _objectWithoutProperties2.default)(props, ["navHeight"]);
  return _react.default.createElement(_UIPage.default, rest);
}).withConfig({
  displayName: "UIAbstractPageTemplate__StyledPage",
  componentId: "zm9u16-0"
})(_templateObject(), _colors.OLAF, function (_ref) {
  var navHeight = _ref.navHeight;
  return (0, _Styles.toPx)(navHeight);
});

function UIAbstractPageTemplate(_ref2) {
  var alertComponent = _ref2.alertComponent,
      asDevice = _ref2.asDevice,
      bodyClassName = _ref2.bodyClassName,
      children = _ref2.children,
      className = _ref2.className,
      contentAreaFlush = _ref2.contentAreaFlush,
      headerComponent = _ref2.headerComponent,
      horizontalDivider = _ref2.horizontalDivider,
      narrowLayout = _ref2.narrowLayout,
      MainSection = _ref2.MainSection,
      mainSectionBackgroundColor = _ref2.mainSectionBackgroundColor,
      mainSectionStyle = _ref2.mainSectionStyle,
      navHeight = _ref2.navHeight,
      pageBackgroundColor = _ref2.pageBackgroundColor,
      pageLayout = _ref2.pageLayout,
      pageMaxWidth = _ref2.pageMaxWidth,
      pageStyle = _ref2.pageStyle,
      sidebarComponent = _ref2.sidebarComponent,
      stickySidebar = _ref2.stickySidebar,
      tabs = _ref2.tabs,
      title = _ref2.title,
      rest = (0, _objectWithoutProperties2.default)(_ref2, ["alertComponent", "asDevice", "bodyClassName", "children", "className", "contentAreaFlush", "headerComponent", "horizontalDivider", "narrowLayout", "MainSection", "mainSectionBackgroundColor", "mainSectionStyle", "navHeight", "pageBackgroundColor", "pageLayout", "pageMaxWidth", "pageStyle", "sidebarComponent", "stickySidebar", "tabs", "title"]);
  var headerUse = tabs ? 'condensed' : undefined;
  var headerWrapperClassNames = (0, _classNames.default)('private-template__section--header');
  var mainWrapperClassNames = (0, _classNames.default)('private-template__section--stretch', {
    'private-template__section--divided': horizontalDivider,
    'private-template--narrow': narrowLayout
  });
  var pageClassName = (0, _classNames.default)('private-template', _PageConstants.DEVICE_CLASSES[asDevice], _PageConstants.LAYOUT_CLASSES[pageLayout], className);
  var sectionClassNames = (0, _classNames.default)({
    'private-template__section--spaced-vertical': !contentAreaFlush,
    'private-template__section--flush': contentAreaFlush
  });

  var templateBackgroundColor = function templateBackgroundColor(color) {
    return {
      backgroundColor: color
    };
  };

  var templateMaxWidth = function templateMaxWidth(width) {
    if (!width) return null;
    return {
      maxWidth: width
    };
  };

  return _react.default.createElement("div", {
    className: "private-ie11-flex-wrapper"
  }, _react.default.createElement(StyledPage, (0, _extends2.default)({}, rest, {
    bodyClassName: getBodyClassNames(bodyClassName, pageLayout),
    className: pageClassName,
    navHeight: (0, _lazyEval.default)(navHeight),
    style: (0, _extends2.default)({}, templateBackgroundColor(pageBackgroundColor), pageStyle)
  }), _react.default.createElement(_UIAbstractPageSection.default, {
    className: headerWrapperClassNames,
    style: (0, _extends2.default)({}, templateMaxWidth(pageMaxWidth))
  }, renderHeader(headerComponent, headerUse, alertComponent, title), tabs), _react.default.createElement("div", {
    className: mainWrapperClassNames,
    style: (0, _extends2.default)({}, mainWrapperBackgroundColor(mainSectionBackgroundColor), mainSectionStyle)
  }, _react.default.createElement(_UIAbstractPageSection.default, {
    className: sectionClassNames,
    style: (0, _extends2.default)({}, templateMaxWidth(pageMaxWidth))
  }, _react.default.createElement(MainSection, {
    sidebarComponent: sidebarComponent,
    stickySidebar: stickySidebar,
    style: (0, _extends2.default)({}, mainWrapperBackgroundColor(mainSectionBackgroundColor), mainSectionStyle)
  }, children)))));
}

var alertDeprecationMsg = {
  key: 'UIAbstractPageTemplate: alert deprecated',
  message: 'Page template: passing both a custom headerComponent and alertComponent can lead ' + 'to unexpected results. Include the alert(s) directly in the headerComponent content ' + 'for more predictable output.\n' + 'For more details, see: https://git.hubteam.com/HubSpot/UIComponents/issues/3934'
};

var getAlertDeprecation = function getAlertDeprecation(name, value) {
  var allProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var header = allProps.headerComponent;

  var hasSafeHeader = value == null || header == null || typeof header === 'function' || _react.default.isValidElement(header) && header.type === _UIHeader.default;

  return !hasSafeHeader ? alertDeprecationMsg : null;
};

UIAbstractPageTemplate.propTypes = {
  alertComponent: (0, _deprecated.default)(_react.PropTypes.node, getAlertDeprecation),
  asDevice: _react.PropTypes.oneOf(['mobile', 'tablet', 'desktop']),
  bodyClassName: _react.PropTypes.string,
  children: _react.PropTypes.node.isRequired,
  contentAreaFlush: _react.PropTypes.bool.isRequired,
  horizontalDivider: _react.PropTypes.bool.isRequired,
  headerComponent: CustomRenderer.propType,
  MainSection: _component.default,
  mainSectionBackgroundColor: _react.PropTypes.string,
  mainSectionComponent: CustomRenderer.propType,
  mainSectionStyle: _react.PropTypes.object,
  narrowLayout: _react.PropTypes.bool.isRequired,
  navHeight: (0, _createLazyPropType.default)(_react.PropTypes.number).isRequired,
  pageBackgroundColor: _react.PropTypes.string,
  pageLayout: _react.PropTypes.oneOf(Object.keys(_PageConstants.LAYOUT_CLASSES)),
  pageMaxWidth: _react.PropTypes.number,
  pageStyle: _react.PropTypes.object,
  sidebarComponent: CustomRenderer.propType,
  stickySidebar: _react.PropTypes.bool,
  tabs: _react.PropTypes.node,
  title: _react.PropTypes.node
};
UIAbstractPageTemplate.defaultProps = {
  contentAreaFlush: false,
  headerComponent: _UIHeader.default,
  horizontalDivider: false,
  MainSection: _UIAbstractPageGridContent.default,
  narrowLayout: false,
  navHeight: _NavHeight.getDefaultNavHeight,
  pageLayout: 'max-width',
  stickySidebar: false
};
UIAbstractPageTemplate.displayName = 'UIAbstractPageTemplate';
var _default = UIAbstractPageTemplate;
exports.default = _default;
module.exports = exports.default;